import script from "./formPenilaian.vue?vue&type=script&setup=true&lang=js"
export * from "./formPenilaian.vue?vue&type=script&setup=true&lang=js"

import "./formPenilaian.vue?vue&type=style&index=0&id=aef8b738&lang=css"

const __exports__ = script;

export default __exports__